import logger from './logger';

const dropboxClient = {
  request: async (path, body) => {
    const url = `/api/dropbox${path}`;
    const logId = logger.logRequest('dropbox', 'POST', url, body);
    const startTime = Date.now();

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      
      const duration = Date.now() - startTime;
      const data = await response.json();

      if (!response.ok) {
        const errorMessage = data.error || `HTTP error! status: ${response.status}`;
        logger.logError(logId, new Error(errorMessage), response.status);
        throw new Error(errorMessage);
      }
      
      logger.logResponse(logId, response.status, data, duration);
      return data;

    } catch (error) {
      const duration = Date.now() - startTime;
      logger.logError(logId, error, 'NETWORK_ERROR');
      throw error;
    }
  },

  uploadFile: (path, base64Data) => dropboxClient.request('/upload', { path, fileData: base64Data }),
  listFiles: (path, recursive = false) => dropboxClient.request('/list', { path, recursive }),
  downloadFile: (path) => dropboxClient.request('/download', { path }),
  refreshToken: () => dropboxClient.request('/refresh-token', {}),
};

export default dropboxClient;